import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createLine = (line) => ({
  type: ActionTypes.LINE_CREATE,
  payload: {
    line,
  },
});

export const updateLine = (id, data) => ({
  type: ActionTypes.LINE_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteLine = (id) => ({
  type: ActionTypes.LINE_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createLineRequested = (localId, data) => ({
  type: ActionTypes.LINE_CREATE_REQUESTED,
  payload: {
    localId,
    data,
  },
});

export const createLineSucceeded = (localId, line) => ({
  type: ActionTypes.LINE_CREATE_SUCCEEDED,
  payload: {
    localId,
    line,
  },
});

export const createLineFailed = (localId, error) => ({
  type: ActionTypes.LINE_CREATE_FAILED,
  payload: {
    localId,
    error,
  },
});

export const createLineReceived = (line) => ({
  type: ActionTypes.LINE_CREATE_RECEIVED,
  payload: {
    line,
  },
});

export const updateLineRequested = (id, data) => ({
  type: ActionTypes.LINE_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateLineSucceeded = (line) => ({
  type: ActionTypes.LINE_UPDATE_SUCCEEDED,
  payload: {
    line,
  },
});

export const updateLineFailed = (id, error) => ({
  type: ActionTypes.LINE_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateLineReceived = (line) => ({
  type: ActionTypes.LINE_UPDATE_RECEIVED,
  payload: {
    line,
  },
});

export const deleteLineRequested = (id) => ({
  type: ActionTypes.LINE_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteLineSucceeded = (line) => ({
  type: ActionTypes.LINE_DELETE_SUCCEEDED,
  payload: {
    line,
  },
});

export const deleteLineFailed = (id, error) => ({
  type: ActionTypes.LINE_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteLineReceived = (line) => ({
  type: ActionTypes.LINE_DELETE_RECEIVED,
  payload: {
    line,
  },
});
